'use strict';
// TODO boundaryGap


    require('../coord/cartesian/AxisModel');

    require('./axis/CartesianAxisView');



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/axis.js
// module id = zz1u
// module chunks = 5